import myZoneServiceProvider from '@/api/serviceProviders/my-zone'
import { GetAvailableTicketsResponse, GetAvailableTicketsResponseData, UseTicketResponse, UseTicketResponseData } from '@/types/api/tickets/ticketsResponses'

export const getAvailable = async (): Promise <GetAvailableTicketsResponseData> => {
    const response = await myZoneServiceProvider.get('tickets/available') as GetAvailableTicketsResponse

    return response.data.data
}

export const useTicket = async (ticketId: string): Promise <UseTicketResponseData> => {
    const response = await myZoneServiceProvider.post('tickets/' + ticketId + '/use') as UseTicketResponse

    return response.data.data
}